import React from "react";
import Checkbox from "components/common/Checkbox";
import OnboardNetworkModal from "components/ops-mgmt/account/publishers/gam-accounts/OnboardNetworkModal";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import NetworkTextDisplay from "components/common/NetworkTextDisplay";
import { thClass, tdClass, buttonConfirmClass } from "helpers/StyleClass.js";
import DateTimeFormatter from "components/common/DateTimeFormatter";

class OnboardNetwork extends React.Component {
  constructor(props) {
    super(props);

    const { networks } = props;
    this.state = {
      isOpenNetworkModal: false,

      networkData: networks,
      selected: this.props.selectedNetwork
        ? this.props.selectedNetwork.networkId
        : null,
    };

    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleCloseNetworkModal = this.handleCloseNetworkModal.bind(this);
    this.handleFinishNetworkOnboard =
      this.handleFinishNetworkOnboard.bind(this);
  }

  async componentDidMount() {
    const { networks } = this.props;
    const { selected } = this.state;

    if (networks && networks.length === 1 && !selected) {
      this.handleCheckChange(networks[0].networkId);
    }
  }

  handleCheckChange(networkId) {
    const { selected, networkData } = this.state;
    const changed = selected === networkId ? null : networkId;
    this.setState({
      selected: changed,
    });

    const network = networkData.find((item) => item.networkId === changed);
    this.props.handleChange(network);
  }

  handleCloseNetworkModal() {
    this.setState({ isOpenNetworkModal: false });
  }

  handleFinishNetworkOnboard({ network }) {
    this.setState(
      (prevState) => ({
        networkData: [...prevState.networkData, network],
        isOpenNetworkModal: false,
      }),
      () => {
        this.handleCheckChange(network.networkId);
      }
    );
  }

  render() {
    const { accountId } = this.props;
    const { networkData, selected, isOpenNetworkModal } = this.state;

    return (
      <div className="mx-auto w-10/12">
        <div className="mb-2 flex justify-end">
          <button
            className={buttonConfirmClass}
            onClick={() => {
              this.setState({ isOpenNetworkModal: true });
            }}
          >
            Add Network
          </button>
        </div>

        <table className="shadow divide-y min-w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className={`${thClass}`} style={{ width: "2rem" }}></th>
              <th className={thClass}>Network</th>
              <th className={`${thClass} w-32`}>Product</th>
              <th className={`${thClass} w-48`}>Created At</th>
            </tr>
          </thead>
          <tbody className="divide-y bg-white text-sm">
            {networkData.map((network, idx) => (
              <HighLightRowWrapper
                selected={selected === network.networkId}
                key={`${network.networkId}-${idx}`}
                onClick={() => {
                  this.handleCheckChange(network.networkId);
                }}
              >
                <td className={tdClass}>
                  <Checkbox
                    isChecked={selected === network.networkId}
                    onChange={() => {
                      this.handleCheckChange(network.networkId);
                    }}
                  ></Checkbox>
                </td>
                <td className={tdClass}>
                  <NetworkTextDisplay network={network}></NetworkTextDisplay>
                </td>
                <td className={tdClass}>{network.product}</td>
                <td className={tdClass}>
                  <DateTimeFormatter
                    datetime={network.createdAt}
                    isLineBreak={true}
                  ></DateTimeFormatter>
                </td>
              </HighLightRowWrapper>
            ))}
          </tbody>
        </table>

        {isOpenNetworkModal && (
          <OnboardNetworkModal
            accountId={accountId}
            onFinished={this.handleFinishNetworkOnboard}
            onClose={this.handleCloseNetworkModal}
            onLoading={(isLoading) => this.props.handleLoading(isLoading)}
          ></OnboardNetworkModal>
        )}
      </div>
    );
  }
}

class NetworkPropsList extends React.Component {
  render() {
    const { title, list } = this.props;
    return (
      <div className="pb-2 pt-1 text-xs text-gray-900">
        <span>
          {title} ({(list || []).length}):{" "}
        </span>
        <div className="flex flex-wrap gap-x-2 gap-y-1">
          {list
            ? list.map((d) => {
                return (
                  <div
                    key={d}
                    className="rounded bg-gray-300 px-2 text-xs text-gray-800"
                  >
                    {d}
                  </div>
                );
              })
            : "--"}
        </div>
      </div>
    );
  }
}
export default OnboardNetwork;
